var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","display":"flex","align-items":"center"}},[_c('Input',{attrs:{"value":_vm.value,"icon":_vm.iosCall},on:{"on-change":_vm.onChange,"on-click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }